exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-form {\n  float: left;\n  width: 140px;\n  padding: 6px;\n  padding-top: 30px; }\n\n.custom-form input, .custom-form select, .custom-form button {\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 1px 5px;\n  font-size: 12px;\n  color: #3b3b3b; }\n\n.dot-flashing {\n  display: none;\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8); }\n\n.isDisabledBtn .dot-flashing {\n  display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/devices/devices.component.scss
// module id = ../../../../../src/app/profile/devices/devices.component.scss
// module chunks = main